<div class="">
  <!-- Content Header -->
  <div class="content-header">
    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col-sm-6">
          <h1 class="m-0">
            Banners
            <button type="button" class="btn btn-sm btn-primary ms-1 btn-" (click)="openBannerModal()"
              title="Add Banner">
              <i class="fas fa-plus"></i>
            </button>
          </h1>
        </div>
      </div>
    </div>
  </div>

  <!-- Banners Table -->
  <div class="card glass-card border-0 shadow-lg rounded-4 p-3">
    <div class="table-responsive table-scroll-wrapper">
      <table class="table table-hover stylish-table align-middle mb-0">
        <thead class="text-white table-header">
          <tr>
            <th class="text-center">Sr.No</th>
            <th class="text-center">Banner Title</th>
            <th class="text-center">Location</th>
            <th class="text-center">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let banner of banners; let i = index">
            <td class="text-center">{{ i + 1 }}</td>
            <td class="fw-semibold text-center">{{ banner.bannerTitle }}</td>
            <td class="text-center">{{ banner.location || 'N/A' }}</td>
            <td class="text-center">
              <i class="bi bi-eye icon-action text-success" title="View Banner Details"
                (click)="viewBanner(banner.bannerDetailsSeq)" style="cursor: pointer; margin-right: 10px;"></i>
              <i class="bi bi-pencil-square icon-action text-primary" title="Edit Banner"
                (click)="editBanner(banner.bannerDetailsSeq)" style="cursor: pointer; margin-left: 5px;"></i>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- No Banners Message -->
  <div class="alert alert-info" *ngIf="banners.length === 0">
    <p class="mb-0">No banners found. Click the <strong><i class="fas fa-plus"></i></strong> button above to add a new
      banner.</p>
  </div>
</div>

<!-- Banner Modal -->
<div class="modal fade" id="bannerModal" tabindex="-1" [ngClass]="{'show': showBannerModal}"
  [style.display]="showBannerModal ? 'block' : 'none'">
  <div class="modal-dialog modal-lg modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center">
          <h5 class="modal-title mb-0">{{ bannerForm.get('bannerTitle')?.value ? 'Edit Banner' : 'Add Banner' }}</h5>
          <!-- Banner Delete Icon -->
          <button *ngIf="bannerForm.get('bannerTitle')?.value && bannerForm.get('bannerDetailsSeq')?.value"
            type="button" class="btn btn-sm btn-danger ms-3"
            (click)="deleteBanner(bannerForm.get('bannerDetailsSeq')?.value)" title="Delete Banner">
            <i class="fas fa-trash"></i>
          </button>
        </div>
        <button type="button" class="btn-close" (click)="closeBannerModal()"></button>
      </div>

      <div class="modal-body">
        <form [formGroup]="bannerForm">
          <!-- Banner Title -->
          <div class="form-group mb-3">
            <label for="bannerTitle">Banner Title</label>
            <input type="text" class="form-control" id="bannerTitle" formControlName="bannerTitle"
              placeholder="Enter banner title">
          </div>

          <!-- Location -->
          <div class="form-group mb-3">
            <label for="location">Location</label>
            <input type="text" class="form-control" id="location" formControlName="location"
              placeholder="Enter location">
          </div>

          <!-- Start Date and End Date -->
          <div class="row">
            <div class="col-md-6">
              <div class="form-group mb-3">
                <label for="startDate">Start Date</label>
                <input type="date" class="form-control" id="startDate" formControlName="startDate">
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group mb-3">
                <label for="endDate">End Date</label>
                <input type="date" class="form-control" id="endDate" formControlName="endDate">
              </div>
            </div>
          </div>

          <!-- Start Time and End Time -->
          <div class="row">
            <div class="col-md-6">
              <div class="form-group mb-3">
                <label for="startTime">Start Time</label>
                <input type="time" class="form-control" id="startTime" formControlName="startTime">
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group mb-3">
                <label for="endTime">End Time</label>
                <input type="time" class="form-control" id="endTime" formControlName="endTime">
              </div>
            </div>
          </div>

          <!-- Banner Image -->
          <div class="form-group mb-3">
            <label for="bannerImage">Banner Image</label>
            <input type="file" class="form-control" id="bannerImage" accept="image/*" (change)="onFileChange($event)">
            <small class="form-text text-muted">Select an image file for the banner</small>
          </div>

          <!-- Short Description -->
          <div class="form-group mb-3">
            <label for="shortDescription">Short Description</label>
            <textarea class="form-control" id="shortDescription" formControlName="shortDescription" rows="2"
              placeholder="Enter short description"></textarea>
          </div>

          <!-- Description -->
          <div class="form-group mb-3">
            <label for="description">Description</label>
            <textarea class="form-control" id="description" formControlName="description" rows="3"
              placeholder="Enter detailed description"></textarea>
          </div>
        </form>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeBannerModal()">Close</button>
        <button *ngIf="bannerForm.get('bannerDetailsSeq')" type="button" class="btn btn-primary"
          (click)="onSubmit()">Update Banner</button>
        <button *ngIf="!bannerForm.get('bannerDetailsSeq')" type="button" class="btn btn-primary"
          (click)="onSubmit()">Save Banner</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal Backdrop -->
<div class="modal-backdrop fade" [ngClass]="{'show': showBannerModal}"
  [style.display]="showBannerModal ? 'block' : 'none'"></div>

<!-- View Banner Modal -->
<div class="modal fade" id="viewBannerModal" tabindex="-1" [ngClass]="{'show': showViewModal}"
  [style.display]="showViewModal ? 'block' : 'none'">
  <div class="modal-dialog modal-lg modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center">
          <h5 class="modal-title mb-0">Banner Details</h5>
          <button *ngIf="selectedBanner?.bannerDetailsSeq" type="button" class="btn btn-sm btn-danger ms-3"
            (click)="deleteBanner(selectedBanner.bannerDetailsSeq)" title="Delete Banner">
            <i class="fas fa-trash"></i>
          </button>
        </div>
        <button type="button" class="btn-close" (click)="closeViewModal()"></button>
      </div>
      <div class="modal-body" *ngIf="selectedBanner">
        <!-- Loading Indicator -->
        <div *ngIf="isLoadingViewModal" class="text-center py-5">
          <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          <p class="mt-2">Loading banner details...</p>
        </div>

        <!-- Content -->
        <div *ngIf="!isLoadingViewModal">
          <!-- Banner Title -->
          <div class="mb-3">
            <h6 class="fw-semibold">Banner Title:</h6>
            <p>{{ selectedBanner.bannerTitle }}</p>
          </div>

          <!-- Location -->
          <div class="mb-3">
            <h6 class="fw-semibold">Location:</h6>
            <p>{{ selectedBanner.location || 'N/A' }}</p>
          </div>

          <!-- Start Date and End Date -->
          <div class="row mb-3">
            <div class="col-md-6">
              <h6 class="fw-semibold text-muted">Start Date:</h6>
              <p class="mb-0">{{ selectedBanner.startDate ? (selectedBanner.startDate | date: 'medium') : 'N/A' }}</p>
            </div>
            <div class="col-md-6">
              <h6 class="fw-semibold text-muted">End Date:</h6>
              <p class="mb-0">{{ selectedBanner.endDate ? (selectedBanner.endDate | date: 'medium') : 'N/A' }}</p>
            </div>
          </div>

          <!-- Start Time and End Time -->
          <div class="row mb-3">
            <div class="col-md-6">
              <h6 class="fw-semibold text-muted">Start Time:</h6>
              <p class="mb-0">{{ selectedBanner.startTime || 'N/A' }}</p>
            </div>
            <div class="col-md-6">
              <h6 class="fw-semibold text-muted">End Time:</h6>
              <p class="mb-0">{{ selectedBanner.endTime || 'N/A' }}</p>
            </div>
          </div>

          <!-- Short Description -->
          <div class="mb-3">
            <h6 class="fw-semibold text-muted">Short Description:</h6>
            <p class="mb-0">{{ selectedBanner.shortDescription || 'N/A' }}</p>
          </div>

          <!-- Description -->
          <div class="mb-3">
            <h6 class="fw-semibold text-muted">Description:</h6>
            <p class="mb-0">{{ selectedBanner.description || 'N/A' }}</p>
          </div>

          <!-- Banner Image -->
          <div class="mb-3" *ngIf="bannerImages[selectedBanner.bannerDetailsSeq] || selectedBanner.bannerImagePath">
            <h6 class="fw-semibold text-muted">Banner Image:</h6>
            <img *ngIf="bannerImages[selectedBanner.bannerDetailsSeq]"
              [src]="bannerImages[selectedBanner.bannerDetailsSeq]" alt="Banner" class="img-fluid"
              style="max-height: 300px;">
          </div>

          <!-- Status (if available) -->
          <div class="mb-3" *ngIf="selectedBanner.status">
            <h6 class="fw-semibold text-muted">Status:</h6>
            <p class="mb-0">{{ selectedBanner.status }}</p>
          </div>

          <!-- Created At (if available) -->
          <div class="mb-3" *ngIf="selectedBanner.createdAt">
            <h6 class="fw-semibold text-muted">Created At:</h6>
            <p class="mb-0">{{ selectedBanner.createdAt | date: 'medium' }}</p>
          </div>

          <!-- Updated At (if available) -->
          <div class="mb-3" *ngIf="selectedBanner.updatedAt">
            <h6 class="fw-semibold text-muted">Updated At:</h6>
            <p class="mb-0">{{ selectedBanner.updatedAt | date: 'medium' }}</p>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeViewModal()">Close</button>
        <button type="button" class="btn btn-primary" (click)="editBanner(selectedBanner.bannerDetailsSeq)">Edit
          Banner</button>
      </div>
    </div>
  </div>
</div>

<!-- View Banner Modal Backdrop -->
<div class="modal-backdrop fade" [ngClass]="{'show': showViewModal}" [style.display]="showViewModal ? 'block' : 'none'">
</div>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium">
  <div class="loader">
    <div class="inner one"></div>
    <div class="inner two"></div>
    <div class="inner three"></div>
  </div>
</ngx-spinner>